'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberIdInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('../../lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberIdInvariant = exports.numberIdInvariant = function numberIdInvariant(id) {
  var parsed = parseInt(id, 10);

  (0, _invariant2.default)(typeof parsed === 'number' && !isNaN(parsed), 'Expected id to be parsable as a number not a %s', typeof indexedData === 'undefined' ? 'undefined' : _typeof(indexedData));
};